<template>
  <div id="preenchimento-do-cadastro">
    <p class="title">Preencha com seus dados</p>



    <v-form class="forms" ref="myForm" validate-on="submit lazy" @submit.prevent="onSubmit" v-model="form">
      <v-container>
        <p class="subtitle">Informações da pessoa {{ subtitlePessoa }}:</p>

        <div>
          <p class="label">Nome completo* </p>
          <v-text-field density="compact" variant="outlined" v-model="participanteName" :rules="[required]"
            placeholder="Digite o nome completo" required>
          </v-text-field>
        </div>

        <div>
          <p class="label">Nome social <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/56c0ecd8-009a-44f4-b674-fe2dd9d6562c.png" @click="modalNomeSocial = true" alt="" style="cursor: pointer; width: 4%;"></p>
          <v-text-field density="compact" variant="outlined" v-model="socialName" placeholder="Digite o seu nome social"
            required>
          </v-text-field>
        </div>

        <div>
          <p class="label">CPF*</p>
          <v-text-field density="compact" @keypress="numbersOnly" variant="outlined" v-model="cpf" :rules="[required, cpfValidation]"
            placeholder="Digite o seu CPF" @input="clearCpf()" required maxlength="11" :error-messages="errors[0]">
          </v-text-field>
        </div>

        <div v-if="['gestante'].includes(profileName)">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="width: 50%;">
              <p class="label">Data provável do parto*</p>
              <v-text-field density="compact" type="date" v-model="dataProvavelParto" variant="outlined" :rules="[required, validateDateRange]" required></v-text-field>
            </div>
            <div style="width: 48%;">
              <p class="label">Gestação de risco?*</p>
              <v-select style="width: 100%;" v-model="gestacaoRisco" density="compact"
                :items="[{title: 'Alto', value: 'alto'}, {title: 'Baixo', value:'baixo'}]" :rules="[required]" variant="outlined">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
            </div>
          </div>
          <p class="label">Idade gestacional*</p>
          <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <v-select style="width: 48%; margin-right:2%;" v-model="idadeGestacionalSemanas" density="compact"
              :items="[{title: '0 semana', value: '0'}, {title: '1 semana', value: '1'}, {title: '2 semanas', value: '2'}, {title: '3 semanas', value: '3'}, {title: '4 semanas', value: '4'}, {title: '5 semanas', value: '5'}, {title: '6 semanas', value: '6'}, {title: '7 semanas', value: '7'}, {title: '8 semanas', value: '8'}, {title: '9 semanas', value: '9'}, {title: '10 semanas', value: '10'}, {title: '11 semanas', value: '11'}, {title: '12 semanas', value: '12'}, {title: '13 semanas', value: '13'}, {title: '14 semanas', value: '14'}, {title: '15 semanas', value: '15'}, {title: '16 semanas', value: '16'}, {title: '17 semanas', value: '17'}, {title: '18 semanas', value: '18'}, {title: '19 semanas', value: '19'}, {title: '20 semanas', value: '20'}, {title: '21 semanas', value: '21'}, {title: '22 semanas', value: '22'}, {title: '23 semanas', value: '23'}, {title: '24 semanas', value: '24'}, {title: '25 semanas', value: '25'}, {title: '26 semanas', value: '26'}, {title: '27 semanas', value: '27'}, {title: '28 semanas', value: '28'}, {title: '29 semanas', value: '29'}, {title: '30 semanas', value: '30'}, {title: '31 semanas', value: '31'}, {title: '32 semanas', value: '32'}, {title: '33 semanas', value: '33'}, {title: '34 semanas', value: '34'}, {title: '35 semanas', value: '35'}, {title: '36 semanas', value: '36'}, {title: '37 semanas', value: '37'}, {title: '38 semanas', value: '38'}, {title: '39 semanas', value: '39'}, {title: '40 semanas', value: '40'}]"
              variant="outlined" :rules="[required]">
              <template v-slot:append-inner>
                <img
                  src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                  alt="">
              </template>
            </v-select>
            <v-select style="margin-left:2%; width: 48%;" v-model="idadeGestacionalDias" density="compact"
              :items="[{title: '0 dia', value: '0'}, {title: '1 dia', value: '1'}, {title: '2 dias', value: '2'}, {title: '3 dias', value: '3'}, {title: '4 dias', value: '4'}, {title: '5 dias', value: '5'}, {title: '6 dias', value: '6'}]"
              variant="outlined" :rules="[required]">
              <template v-slot:append-inner>
                <img
                  src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                  alt="">
              </template>
            </v-select>
          </div>
        </div>

        <div>
          <p class="label">Tipo de deficiência</p>
          <v-text-field density="compact" variant="outlined" v-model="tipoDeficiencia"
            placeholder="Digite se possue alguma deficiência" required>
          </v-text-field>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="width: 48%;">
            <p class="label">Titularidade*</p>
            <v-select style="width: 100%;" v-model="titularidade" density="compact"
              :items="[{title:'Titular', value:'titular'}, {title:'Dependente', value:'dependente'}]" variant="outlined" :rules="[required]">
              <template v-slot:append-inner>
                <img
                  src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                  alt="">
              </template>
            </v-select>
          </div>
          <div style="width: 48%;">
            <p class="label">Data de nascimento*</p>
            <v-text-field density="compact" type="date" v-model="dataNascimento" variant="outlined" :rules="[required]" required></v-text-field>
          </div>

        </div>

        <div v-if="titularidade === 'titular'">

          <p class="label">Área*</p>
          <v-select style="width: 100%;" v-model="titularidadeArea" density="compact"
            :items="Object.keys(cargosPorArea)"  variant="outlined" required :rules="[required]">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-select>

          <p class="label">Cargo*</p>
          
          <v-autocomplete
            v-model="titularidadeCargo"
            v-model:search="search"
            :items="cargosDisponiveis"
            density="compact"
            variant="outlined"
            :menu-props="{
              maxHeight: 300,
              maxWidth: 400
            }"
            eager="false"
            hide-no-data
            no-filter
            style="width: 100%;" 
            :disabled="!titularidadeArea" 
            required
            :rules="[required]"
            @update:search="loadCargos"
            :loading="loadingCargos">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-autocomplete>

          <div>
            <p class="label">Nivel*</p>
            <v-select style="width: 100%;" v-model="executivoCargo" density="compact"
                :items="[{title:'Executivo', value:'executivo'}, {title:'Aprendiz', value:'aprendiz'}, {title:'Outros', value:'outros'}]" variant="outlined" :rules="[required]">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
          </div>
        </div>

        <div v-if="titularidade === 'dependente'">
          <p class="label">Email do titular*</p>
          <v-text-field density="compact" variant="outlined" v-model="emailTitular" :rules="[required, email]"
            placeholder="Digite o email do titular" required>
          </v-text-field>
          <p class="label">Nome do titular*</p>
          <v-text-field density="compact" variant="outlined" v-model="nomeTitular" :rules="[required]"
            placeholder="Digite o nome do titular" required>
          </v-text-field>
          <p class="label">CPF do titular*</p>
          <v-text-field density="compact" @keypress="numbersOnly" maxlength="11" variant="outlined" v-model="cpfTitular" :rules="[required, cpfValidation]"
            placeholder="Digite o CPF do titular" required>
          </v-text-field>
        </div>

        <div v-if="!['processo_adotivo'].includes(profileName)">
          <p class="label">Email corporativo do titular*</p>
          <v-text-field density="compact" variant="outlined" v-model="emailCorporativo" :rules="[required, email]"
            placeholder="Digite o seu email particular" required>
          </v-text-field>
        </div>


        <div>
          <p class="label">Grau de escolaridade</p>
          <v-select :rules="[required]" v-model="grauDeEscolaridade" density="compact"
            :items="[{title:'Fundamental - Incompleto', value: 'fundamental_incompleto'}, {title:'Fundamental - Completo', value:'fundamental_completo'}, {title:'Médio - Incompleto', value:'medio_incompleto'}, {title:'Médio - Completo', value:'medio_completo'}, {title:'Superior - Incompleto', value:'superior_incompleto'}, {title:'Superior - Completo', value:'superior_completo'}, {title:'Pós-graduação - Incompleto', value:'pos_incompleto'}, {title:'Pós-graduação - Completo', value:'pos_completo'}]" variant="outlined">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-select>
        </div>

        <div>
          <p class="label">Matrícula do colaborador*</p>
          <v-text-field density="compact" @keypress="callValidate" variant="outlined" v-model="matriculaColaborador"
            :rules="[required]" placeholder="Digite sua matrícula" required>
          </v-text-field>
        </div>

        <div>
          <p class="label">Cep* (Apenas números)</p>
          <v-text-field density="compact" @keypress="numbersOnly" variant="outlined" v-model="cep" :rules="[required, validCep]"
            placeholder="Digite o seu CEP" maxlength="8" required>
          </v-text-field>
        </div>

        <div>
          <p class="label">Endereço residencial*</p>
          <v-text-field density="compact" variant="outlined" v-model="endereco" :rules="[required]"
            placeholder="Digite seu endereço" required>
          </v-text-field>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between;">

          <div style="width: 48%">
            <p class="label">Número*</p>
            <v-text-field density="compact" variant="outlined" v-model="numero" :rules="[required]" placeholder="Digite"
              required>
            </v-text-field>
          </div>
          <div style="width: 48%;">
            <p class="label">Bairro*</p>
            <v-text-field density="compact" variant="outlined" v-model="bairro" :rules="[required]" placeholder="Digite"
              required>
            </v-text-field>
          </div>

        </div>

        <div>
          <p class="label">Complemento*</p>
          <v-text-field density="compact" variant="outlined" v-model="complemento" :rules="[required]"
            placeholder="Digite o complemento" required>
          </v-text-field>
        </div>

        <div style="display: flex; align-items: center;justify-content: space-between;">
          <div style="width: 48%;">
            <div>
              <p class="label">Cidade*</p>
              <v-text-field density="compact" variant="outlined" v-model="cidade" :rules="[required]" placeholder="Digite"
                required>
              </v-text-field>
            </div>
          </div>

          <div style="width: 48%;">
            <div>
              <p class="label">Estado*</p>
              <v-text-field density="compact" variant="outlined" v-model="estado" :rules="[required]" placeholder="Digite"
                required>
              </v-text-field>
            </div>
          </div>
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="width: 48%;">
            <div>
              <p class="label">Telefone (whatsapp)*</p>
              <v-text-field density="compact" variant="outlined" v-model="telefone" :rules="[required, phone]"
                placeholder="Digite" @keypress="numbersOnly" required>
              </v-text-field>
            </div>
          </div>

          <div style="width: 48%;">
            <div>
              <p class="label">Telefone secundário</p>
              <v-text-field @keypress="numbersOnly" density="compact" variant="outlined" v-model="telefoneSecundario"
                placeholder="Digite">
              </v-text-field>
            </div>
          </div>
        </div>


        <div>
          <p class="label">Qual o melhor período para contato telefônico?*</p>
          <v-select style="width: 100%;" :rules="[required]" v-model="periodo" density="compact"
            :items="['08-12h', '13-17h', '17-19h']" variant="outlined">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-select>
        </div>

        <div>
          <p class="label">Email particular*</p>
          <v-text-field density="compact" variant="outlined" v-model="emailParticular" :rules="[required, email]"
            placeholder="Digite o seu email particular" required>
          </v-text-field>
        </div>


        <div>
          <p class="label">Convênio*</p>
          <v-select :rules="[required]" v-model="convenio" density="compact" :items="['Sulamérica', 'CNU']"
            variant="outlined">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-select>
        </div>

        <div v-if="['gestante', 'fui_gestante'].includes(profileName)">
          <p class="label">Número da carteirinha do plano*</p>
          <v-text-field density="compact" variant="outlined" v-model="carteirinhaPlano" :rules="[required]"
            placeholder="Digite" @keypress="numbersOnly" required>
          </v-text-field>
          <p class="label" style="font-size: 12px; margin-bottom: 5%; font-style: italic;">*Onde será realizado o desconto da coparticipação</p>
        </div>

        <div v-if="['fui_gestante'].includes(profileName)">
          <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <div style="width: 48%;">
              <p class="label">Data do parto*</p>
              <v-text-field density="compact" type="date" v-model="dataParto" variant="outlined" :rules="[required]" required></v-text-field>
            </div>
            <div style="width: 48%;">
              <p class="label">Tipo do parto*</p>
              <v-select style="width: 100%;" v-model="tipoParto" density="compact"
              :items="[{title: 'Natural', value: 'natural'}, {title: 'Normal', value:'normal'}, {title: 'Normal Induzido', value:'normal_induzido'}, {title: 'Cesarea', value:'cesarea'}, {title: 'Cesarea Intraparto', value:'cesarea_intraparto'}, {title: 'Forceps', value:'forceps'}]" :rules="[required]" variant="outlined">
              <template v-slot:append-inner>
                <img
                  src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                  alt="">
              </template>
            </v-select>
            </div>
          </div>
        </div>

        <div v-if="['gestante'].includes(profileName)">
          <p class="label">Qual a data da última menstruação?*</p>
          <v-text-field density="compact" type="date" v-model="dataMenstruação" variant="outlined" :rules="[required]" required></v-text-field>
          <p class="label mt-1">Anexo do exame de Ultrassom com idade gestacional (O arquivo enviado deve, obrigatoriamente, conter o laudo do exame.)**</p>
          <v-file-input density="compact" :rules="[required]" :prepend-icon="null" v-model="exameUltrassom" label="Exame de Ultrassom"
            variant="outlined" accept="application/pdf,image/*" @change="upload(exameUltrassom, 'ultrassom')">
            <template v-slot:append-inner>
              <img
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/96ed24e9-194e-4e45-9073-81efa9b8cb84.svg"
                alt="">
            </template>
          </v-file-input>
        </div>

        <div v-if="['parceria', 'parceira_e_bebe_nasceu'].includes(profileName)">
          <p class="label">A gestante participa ou está inscrita no programa?</p>
          <v-select style="width: 100%;" v-model="gestanteParticipa" density="compact"
            :items="['Sim', 'Não']" :rules="[required]" variant="outlined">
            <template v-slot:append-inner>
              <img
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                alt="">
            </template>
          </v-select>
        </div>

        <div v-if="!['gestante', 'fui_gestante', 'processo_adotivo'].includes(profileName)">
          <p class="subtitle">Informações da pessoa gestante:</p>
            <p class="label">Nome da pessoa gestante*</p>
            <v-text-field density="compact" variant="outlined" v-model="nomeGestante" :rules="[required]"
              placeholder="Digite o nome da pessoa gestante" required>
            </v-text-field>
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <div style="width: 48%;">
              <p class="label">CPF*</p>
              <v-text-field density="compact" variant="outlined" v-model="cpfGestante" :rules="[required, cpfValidation]"
                placeholder="Digite o CPF da parceira gestante" @keypress="numbersOnly" maxlength="11" required>
              </v-text-field>
            </div>
            <div style="width: 48%;">
              <p class="label">Data de nascimento*</p>
              <v-text-field density="compact" type="date" v-model="dataNascimentoGestante" variant="outlined" :rules="[required]" required></v-text-field>
            </div>
          </div>
          <div v-if="['parceria'].includes(profileName)">
            <p class="label">Idade gestacional*</p>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <v-select style="width: 48%; margin-right:2%;" v-model="idadeGestacionalSemanas" density="compact"
              :items="[{title: '0 semana', value: '0'}, {title: '1 semana', value: '1'}, {title: '2 semanas', value: '2'}, {title: '3 semanas', value: '3'}, {title: '4 semanas', value: '4'}, {title: '5 semanas', value: '5'}, {title: '6 semanas', value: '6'}, {title: '7 semanas', value: '7'}, {title: '8 semanas', value: '8'}, {title: '9 semanas', value: '9'}, {title: '10 semanas', value: '10'}, {title: '11 semanas', value: '11'}, {title: '12 semanas', value: '12'}, {title: '13 semanas', value: '13'}, {title: '14 semanas', value: '14'}, {title: '15 semanas', value: '15'}, {title: '16 semanas', value: '16'}, {title: '17 semanas', value: '17'}, {title: '18 semanas', value: '18'}, {title: '19 semanas', value: '19'}, {title: '20 semanas', value: '20'}, {title: '21 semanas', value: '21'}, {title: '22 semanas', value: '22'}, {title: '23 semanas', value: '23'}, {title: '24 semanas', value: '24'}, {title: '25 semanas', value: '25'}, {title: '26 semanas', value: '26'}, {title: '27 semanas', value: '27'}, {title: '28 semanas', value: '28'}, {title: '29 semanas', value: '29'}, {title: '30 semanas', value: '30'}, {title: '31 semanas', value: '31'}, {title: '32 semanas', value: '32'}, {title: '33 semanas', value: '33'}, {title: '34 semanas', value: '34'}, {title: '35 semanas', value: '35'}, {title: '36 semanas', value: '36'}, {title: '37 semanas', value: '37'}, {title: '38 semanas', value: '38'}, {title: '39 semanas', value: '39'}, {title: '40 semanas', value: '40'}]"
                variant="outlined" :rules="[required]">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
              <v-select style="margin-left:2%; width: 48%;" v-model="idadeGestacionalDias" density="compact"
                :items="[{title: '0 dia', value: '0'}, {title: '1 dia', value: '1'}, {title: '2 dias', value: '2'}, {title: '3 dias', value: '3'}, {title: '4 dias', value: '4'}, {title: '5 dias', value: '5'}, {title: '6 dias', value: '6'}]"
                variant="outlined" :rules="[required]">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
            </div>
            <div>
              <p class="label">Data provável do parto*</p>
              <v-text-field density="compact" type="date" v-model="dataProvavelParto" variant="outlined" :rules="[required]" required></v-text-field>
            </div>
            <div>
              <p class="label">Gestação de risco?*</p>
              <v-select style="width: 100%;" v-model="gestacaoRisco" density="compact"
                :items="[{title: 'Alto', value: 'alto'}, {title: 'Baixo', value:'baixo'}]" :rules="[required]" variant="outlined">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
            </div>
          </div>
          <p class="label">Número da carteirinha do plano*</p>
          <v-text-field density="compact" variant="outlined" v-model="carteirinhaPlano" :rules="[required]"
            placeholder="Digite" @keypress="numbersOnly" required>
          </v-text-field>
          <p class="label" style="font-size: 12px; margin-bottom: 5%; font-style: italic;">*Onde será realizado o desconto da coparticipação</p>
          <div v-if="['parceira_e_bebe_nasceu'].includes(profileName)">
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <div style="width: 48%;">
                <p class="label">Data do parto*</p>
                <v-text-field density="compact" type="date" v-model="dataParto" variant="outlined" :rules="[required]" required></v-text-field>
              </div>
              <div style="width: 48%;">
                <p class="label">Tipo do parto*</p>
                <v-select style="width: 100%;" v-model="tipoParto" density="compact"
                :items="[{title: 'Natural', value: 'natural'}, {title: 'Normal', value:'normal'}, {title: 'Normal Induzido', value:'normal_induzido'}, {title: 'Cesarea', value:'cesarea'}, {title: 'Cesarea Intraparto', value:'cesarea_intraparto'}, {title: 'Forceps', value:'forceps'}]" :rules="[required]" variant="outlined">
                <template v-slot:append-inner>
                  <img
                    src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5c032a07-68ac-4027-9e87-a869bed59770.svg"
                    alt="">
                </template>
              </v-select>
              </div>
            </div>
          </div>
          <div v-if="['parceria'].includes(profileName)">
            <p class="label">Anexo do exame de Ultrassom com idade gestacional (O arquivo enviado deve, obrigatoriamente, conter o laudo do exame.)*</p>
            <v-file-input density="compact" :prepend-icon="null" v-model="exameUltrassom" label="Exame de Ultrassom"
              variant="outlined" @change="upload(exameUltrassom, 'ultrassom')" :rules="[required]" accept="application/pdf,image/*">
              <template v-slot:append-inner>
                <img
                  src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/96ed24e9-194e-4e45-9073-81efa9b8cb84.svg"
                  alt="">
              </template>
            </v-file-input>
            <p class="label">Anexo do exame de Beta HCG (O arquivo enviado deve, obrigatoriamente, conter o laudo do exame.)*</p>
            <v-file-input density="compact" :prepend-icon="null" v-model="exameBeta" label="Exame de Beta HCG"
              variant="outlined" @change="upload(exameBeta, 'beta')" :rules="[required]" accept="application/pdf,image/*">
              <template v-slot:append-inner>
                <img
                  src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/96ed24e9-194e-4e45-9073-81efa9b8cb84.svg"
                  alt="">
              </template>
            </v-file-input>
          </div>
        </div>

      </v-container>

      <div class="checkbox-container">
        <label class="custom-checkbox">
          <input type="checkbox" v-model="checkbox1" />
          <span class="checkmark"></span>
          Estou de acordo com o compartilhamento dos meus dados com a empresa.
        </label>

        <label class="custom-checkbox">
          <input type="checkbox" v-model="checkbox2" />
          <span class="checkmark"></span>
          Confirmo que o meu endereço cadastrado está correto, para que eu possa receber o Kit Boas-Vindas e/ou Kit Bebê corretamente e dentro do prazo estimado.
        </label>
      </div>

      <v-btn class="mt-3" :disabled="!checkbox1 || !checkbox2" type="submit" color="#660099" @click="submitForm">Submeter cadastro</v-btn>

    </v-form>

    <div class="overlay-modal-nome-social" v-if="modalNomeSocial"></div>

  <div class="modal-nome-social" v-if="modalNomeSocial">
    <button class="btn-close" @click="modalNomeSocial = false"><img
        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34acc885-1b03-4a5a-b827-489477f81a78.svg"
        alt=""></button>
    <h5 class="title-modal"><span style="color: #000000;">NOME SOCIAL</span> </h5>
    <p class="descricao-modal">Preencha este campo apenas se você utiliza um nome diferente do nome civil para ser identificado(a).    </p>
    <p class="descricao-modal">O nome social é destinado a pessoas cuja identidade de gênero não é refletida pelo nome civil, como travestis, pessoas trans (homens e mulheres), transgêneros e não binárias. O uso é opcional e garantido por lei.</p>
  </div>

  </div>

  <ModalCamposPreenchidos :cpf="formatCpf(cpf)" v-if="formsCompleted"/>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import { useFelixBagAuxStore } from '../../../store';
import requestApi from '@/utils/requestApi';
import cargosPorArea from '@/utils/cargosPorArea.json';


import ModalCamposPreenchidos from './components/ModalCamposPreenchidos.vue'

import axios from 'axios';


const felixBagAuxStore = useFelixBagAuxStore();

const profileName = ref('')
const form = ref(false)
const formsCompleted = ref(false)

const modalNomeSocial = ref(false);

const subtitlePessoa = computed(() => {
  const map = {
    'gestante': 'gestante',
    'fui_gestante': 'participante',
    'parceria': 'parceira da gestante',
    'parceira_e_bebe_nasceu': 'participante',
    'processo_adotivo': 'participante'
  }
  return map[profileName.value] || 'participante'
})


const socialName = ref('')
const participanteName = ref('')
const cpf = ref('')
const cpfGestante = ref('')
const tipoDeficiencia = ref('')
const titularidade = ref('')
const titularidadeArea = ref('')
const titularidadeCargo = ref('')
const executivoCargo = ref('')
const dataNascimento = ref('')
const dataNascimentoGestante = ref('')
const dataProvavelParto = ref('')
const dataParto = ref('')
const dataMenstruação = ref('')
const grauDeEscolaridade = ref('')
const matriculaColaborador = ref('')
const endereco = ref('')
const numero = ref('')
const bairro = ref('')
const complemento = ref('')
const cidade = ref('')
const estado = ref('')
const cep = ref('')
const telefone = ref('')
const telefoneSecundario = ref('')
const periodo = ref('')
const emailParticular = ref('')
const emailCorporativo = ref('')
const convenio = ref('')
const nomeGestante = ref('')
const idadeGestacionalSemanas = ref('')
const idadeGestacionalDias = ref('')
const tipoParto = ref('')
const gestacaoRisco = ref('')
const carteirinhaPlano = ref('')
const exameUltrassom = ref(null)
const exameBeta = ref(null)
const exameUltrassomUrl = ref('')
const exameBetaUrl = ref('')
const gestanteParticipa = ref('')
const emailTitular = ref('')
const nomeTitular = ref('')
const cpfTitular = ref('')
const errors = ref([''])
const myForm = ref(null)
const search = ref('')
const loadingCargos = ref(false)

const checkbox1 = ref(false)
const checkbox2 = ref(false)

const cargosDisponiveis = ref([])

onMounted(() => {
  felixBagAuxStore.pauseAfter(13000)

  profileName.value = felixBagAuxStore.form.profile.name
});


async function onSubmit(event) {
  const results = await event
  if (results.valid) {
    registerMailing()
  } else {
    myForm.value.scrollTo(0,0)
  }
}

async function upload(file, type) {
  const fileName = `${Date.now()} - ${file[0].name}`;
  try {
    const options = {
      base_key: process.env.VUE_APP_VIDEO_ID,
      file_name: fileName
    };
    const response = await getAWSUploadSignedUrl(options);
    let upload_url = response.data.upload_url;
    if (type === 'beta') {
      exameBetaUrl.value = response.data.public_url
    } else {
      exameUltrassomUrl.value = response.data.public_url
    }
    axios({
      url: upload_url,
      method: "PUT",
      data: file[0],
      headers: { "Content-Type": file[0].type }
    })
  } catch (error) {
    console.error(error);
  }
}

function getAWSUploadSignedUrl(query) {
  return requestApi({
    url: `/upload/signed_url`,
    method: "post",
    data: query,
    headers: {
      'Videobot-Token': localStorage.getItem('TOKEN_VIDEOBOT')
    },
  });
}

function formatDate(data) {
  if (data) {
    let parts = data.split("-");
    let dataFormatada = parts[2] + "/" + parts[1] + "/" + parts[0];
    return dataFormatada;
  } else return ""
}

function formatCpf(data) {
  if (data) {
    let dataFormat = data
    return dataFormat.replace(/[^0-9]/g, '')
  } else return ""
}

function cpfValidation(value) {
  const cleanCPF = value.replace(/[^\d]/g, '');

  if (cleanCPF.length !== 11 || /^(.)\1+$/.test(cleanCPF)) {
    return "Digite um cpf válido";
  }

  let sum = 0;
  let remainder;

  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cleanCPF.substring(9, 10))) {
    return "Digite um cpf válido";
  }

  sum = 0;

  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cleanCPF.substring(10, 11))) {
    return "Digite um cpf válido";
  }

  return true;
}

function numbersOnly(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode < 48 || charCode > 57) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function notAllowStartZero(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  var inputElement = evt.target || evt.srcElement;
  if (inputElement.value.length === 0 && charCode === 48) {
    evt.preventDefault();
    return false;
  }
}

function callValidate(evt) {
  numbersOnly(evt);
  notAllowStartZero(evt);
}

function required(v) {
  if (v) return true

  return "Campo obrigatório"
}

function validateDateRange(v) {
  if (!v) return true

  const selectedDate = new Date(v)
  const today = new Date()

  selectedDate.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)

  const daysDiff = Math.floor((selectedDate - today) / (1000 * 60 * 60 * 24))

  if (daysDiff > 294) {
    return 'Data inválida. O limite da data de parto é de até 42 semanas.'
  }

  if (daysDiff < 0) {
    return 'Data inválida. Data inferior à data atual.'
  }

  return true
}

function phone(value) {
  if (value?.length > 9 && /[0-9-]+/.test(value)) return true

  return 'O telefone precisa ter no mínimo 9 dígitos'
}
function email(value) {
  // Verifica se há acentos ou caracteres especiais não permitidos
  if (/[À-ÖØ-öø-ÿ]/.test(value)) {
    return 'O e-mail não deve conter acentos'
  }

  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return true
  }

  return 'Digite um e-mail válido'
}

function clearCpf() {
  errors.value.splice(0)
}

function bebeNasceu() {
  let bebe_nasceu = ['fui_gestante', 'parceira_e_bebe_nasceu']
  if (bebe_nasceu.includes(felixBagAuxStore.form.profile.name)){
    return 'sim'
  } else {
    return 'nao'
  }
}

function loadCargos() {
  loadingCargos.value = true
  const cargos = cargosPorArea[titularidadeArea.value] || []

  if (!search.value) {
    loadingCargos.value = false
    return []
  }

  cargosDisponiveis.value = cargos.filter(c => c.includes(search.value.toUpperCase()))
    .slice(0, 200)
}

async function registerMailing(){
  const currentDate = new Date();

  requestApi({
    url: '/v3/generate_url',
    method: 'post',
    headers: {
      'Videobot-Token': localStorage.getItem('TOKEN_VIDEOBOT')
    },
    data: {
      "video_id": process.env.VUE_APP_VIDEO_ID,
      "user_id": formatCpf(cpf.value),
      "tag": "teste_com_" + currentDate.toISOString().split('T')[0],
      "data": [
          {
          "type": "string",
          "name": "NOME_CADASTRADO",
          "value": participanteName.value
          },
          {
          "type": "string",
          "name": "NOME_SOCIAL",
          "value": socialName.value
          },
          {
          "type": "string",
          "name": "TIPO_DEFICIENCIA",
          "value": tipoDeficiencia.value
          },
          {
          "type": "string",
          "name": "TITULARIDADE",
          "value": titularidade.value
          },
          {
          "type": "string",
          "name": "MATRICULA",
          "value": formatCpf(matriculaColaborador.value)
          },
          {
          "type": "string",
          "name": "AREA",
          "value": titularidadeArea.value
          },
          {
          "type": "string",
          "name": "CARGO",
          "value": titularidadeCargo.value
          },
          {
          "type": "string",
          "name": "EXECUTIVO",
          "value": executivoCargo.value
          },
          {
          "type": "string",
          "name": "DATA_NASCIMENTO",
          "value": formatDate(dataNascimento.value)
          },
          {
          "type": "string",
          "name": "BEBE_NASCEU",
          "value": bebeNasceu()
          },
          {
          "type": "string",
          "name": "IDADE_GESTACIONAL_SEMANAS",
          "value": idadeGestacionalSemanas.value
          },
          {
          "type": "string",
          "name": "IDADE_GESTACIONAL_DIAS",
          "value": idadeGestacionalDias.value
          },
          {
          "type": "string",
          "name": "DATA_PROVAVEL_PARTO",
          "value": formatDate(dataProvavelParto.value)
          },
          {
          "type": "string",
          "name": "DATA_PARTO",
          "value": formatDate(dataParto.value)
          },
          {
          "type": "string",
          "name": "GRAVIDEZ_DE_RISCO",
          "value": gestacaoRisco.value
          },
          {
          "type": "string",
          "name": "EMAIL_CORPORATIVO",
          "value": emailCorporativo.value
          },
          {
          "type": "string",
          "name": "EMAIL_PESSOAL",
          "value": emailParticular.value,
          },
          {
          "type": "string",
          "name": "ENDERECO_RESIDENCIAL",
          "value": endereco.value
          },
          {
          "type": "string",
          "name": "NUMERO",
          "value": numero.value
          },
          {
          "type": "string",
          "name": "BAIRRO",
          "value": bairro.value
          },
          {
          "type": "string",
          "name": "COMPLEMENTO",
          "value": complemento.value
          },
          {
          "type": "string",
          "name": "CIDADE",
          "value": cidade.value
          },
          {
          "type": "string",
          "name": "ESTADO",
          "value": estado.value
          },
          {
          "type": "string",
          "name": "CEP",
          "value": cep.value
          },
          {
          "type": "string",
          "name": "TELEFONE_WHATSAPP",
          "value": telefone.value
          },
          {
          "type": "string",
          "name": "TELEFONE_SECUNDARIO",
          "value": telefoneSecundario.value
          },
          {
          "type": "string",
          "name": "HORARIO_CONTATO",
          "value": periodo.value
          },
          {
          "type": "string",
          "name": "CONVENIO",
          "value": convenio.value
          },
          {
          "type": "string",
          "name": "NUMERO_CARTEIRAPLANO",
          "value": carteirinhaPlano.value
          },
          {
          "type": "string",
          "name": "GRAU_ESCOLARIDADE",
          "value": grauDeEscolaridade.value
          },
          {
          "type": "string",
          "name": "DATA_ULTIMA_MENSTRUACAO",
          "value": formatDate(dataMenstruação.value)
          },
          {
          "type": "string",
          "name": "ANEXO_EXAME_ULTRASSOM",
          "value": exameUltrassomUrl.value
          },
          {
          "type": "string",
          "name": "NOME_GESTANTE",
          "value": nomeGestante.value
          },
          {
          "type": "string",
          "name": "CPF_GESTANTE",
          "value": formatCpf(cpfGestante.value)
          },
          {
          "type": "string",
          "name": "DATA_NASCIMENTO_GESTANTE",
          "value": formatDate(dataNascimentoGestante.value)
          },
          {
          "type": "string",
          "name": "GESTANTE_PARTICIPA",
          "value": gestanteParticipa.value
          },
          {
          "type": "string",
          "name": "ANEXO_BETA_HCG",
          "value": exameBetaUrl.value
          },
          {
          "type": "string",
          "name": "TRILHA",
          "value": felixBagAuxStore.form.profile.name
          },
          {
          "type": "string",
          "name": "CPF",
          "value": formatCpf(cpf.value)
          },
          {
          "type": "string",
          "name": "NOME_TITULAR",
          "value": nomeTitular.value
          },
          {
          "type": "string",
          "name": "EMAIL_TITULAR",
          "value": emailTitular.value
          },
          {
          "type": "string",
          "name": "CPF_TITULAR",
          "value": formatCpf(cpfTitular.value)
          },
          {
          "type": "string",
          "name": "TIPO_PARTO",
          "value": tipoParto.value
          }
      ]
    }
  }).then(() => {
    formsCompleted.value = true
  }).catch(function (error) {
    errors.value.splice(0)
    if (error.response.data.message === 'Ocorreu um erro ao gerar URL: Já existe um colaborador cadastrado com esse viewer_id') {
      errors.value.push('O CPF já está cadastrado em um programa')
      myForm.value.scrollTo(0,0)
    }
  })
}

watch(cep, (newCep) => {
  console.log(newCep);

  if (/^\d{8}$/.test(newCep)) {
    console.log("aqui");

    const aux = newCep.replace('-', '');
    const apiUrl = `https://viacep.com.br/ws/${aux}/json/`;

    axios.get(apiUrl)
      .then(response => {
        console.log(response);
        cidade.value = response.data.localidade;
        estado.value = response.data.uf;
        bairro.value = response.data.bairro;
        endereco.value = response.data.logradouro;
      })
      .catch(error => {
        console.error('Erro ao buscar CEP:', error);
      });
  } else {
    console.log('Digite um CEP válido');
    // Avisar ao usuário ou realizar outra ação adequada à sua aplicação
  }
});

watch(titularidadeArea, () => {
  if (!titularidadeArea.value) {
    titularidadeCargo.value = null;
    cargosDisponiveis.value = [];
    return
  }

  const cargos = cargosPorArea[titularidadeArea.value] || [];
  if (!cargos.includes(titularidadeCargo.value)) {
    titularidadeCargo.value = null;
  }
  // clear cached list so it will be reloaded on next open
  cargosDisponiveis.value = [];
})
</script>

<style>
.v-input__details {
  text-align: start;
  min-height: 0 !important;
}

.v-messages {
  min-height: 0 !important;
}

.v-field__input {
  font-size: 12px !important;
}

.v-field__input::placeholder {
  font-size: 11px !important;
}

.v-icon {
  display: none !important;
}
</style>

<style scoped>
#preenchimento-do-cadastro {
  width: 100%;
  height: 100%;
}

.title {
  margin-top: 25%;
  color: #fff;
  font-size: 22px;

}

.subtitle {
  color: black;
  font-weight: bold;
  margin-top: 3%;
  text-align: start;
  font-size: 14px;
}

.forms {
  margin-top: 5%;
  overflow: auto;
  height: 65%;
}

.label {
  font-size: 13px;
  text-align: start;
}

.checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 12px;
  width: 88%;
  margin-left: 6%;
  text-align: left;
}

.overlay-modal-nome-social {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000a8;
}

.modal-nome-social {
  position: absolute;
  top: 17%;
  left: 5%;
  width: 90%;
  /* height: 70%; */
  background: #fff;
  border-radius: 8px;
}

.modal-nome-social>.btn-close {
  margin-left: 84%;
  margin-top: 4%;
}

.modal-nome-social>.btn-close>img {
  width: 50%;
}

.modal-nome-social>.img-center {
  width: 50%;
  margin-top: 5%;
}

.modal-nome-social>.title-modal {
  color: #BD4AFF;
  font-size: 1.2em;
  line-height: 1;
  margin-top: 5%;
  width: 80%;
  margin: 5% auto;
}

.modal-nome-social>.descricao-modal {
  color: #686867;
  font-size: 0.8em;
  width: 71%;
  margin: 5% auto;
  line-height: normal;
  width: 90%;
}
</style>